module.exports = __webpack_public_path__ + "img/new3.3d817471.jpg";